import { TextField, Typography } from '@material-ui/core'
import React, { useState } from 'react'
import LoadingButton from '../LoadingButton'
import { red } from '../Colors'

import { updatePurchaseOrderStatusWithComment } from '../../api/resources/PurchaseOrders'

export default function UpdatePurchaseOrderStatus({purchaseOrder, onClose, onStatusChange, status}) {

  const [Comment, setComment] = useState("")
  const [Status] = useState(status)
  const [isSaving, setIsSaving] = useState(false)

  const update = event => {
    const { value } = event.target;
    setComment(value);
  }

  const buttonStyle = {};

  if (Status === 'rejected' || Status === 'canceled' ) {
    buttonStyle.backgroundColor = red;
  }

  const submit = () => {
    setIsSaving(true);
    if (status === 'canceled') {
      if (!confirm('Are you sure you want to cancel this PO? This can\'t be undone.')) {
        setIsSaving(false);
        return false;
      }
    }
    updatePurchaseOrderStatusWithComment(purchaseOrder.id, status, Comment).then(res => {
      onStatusChange(res)
      onClose();
    }).catch(() => {
      alert('Something went wrong');
    })
  }

  const placeholder = {
    rejected: 'Why has this purchase order been rejected?',
    pending: 'Why are you re-submitting this PO request?',
    canceled: 'Why has this purchase order been canceled?'
  }[Status];
  
  const verb = {
    rejected: 'Reject',
    pending: 'Re-submit',
    canceled: 'Cancel'
  }[Status];

  return (
    <div style={{width: '400px'}}>
      <Typography variant='h6'>{verb} purchase order</Typography>
      <div style={{margin: '24px 0 32px'}}>
        <TextField
          multiline
          label='Comment'
          placeholder={placeholder}
          variant='outlined'
          InputLabelProps={{ shrink: true }}
          onChange={update}
          rows={6}
          fullWidth
          value={Comment}
        />
      </div>
      <LoadingButton
        color="primary"
        variant="contained"
        fullWidth
        loading={isSaving}
        onClick={submit}
        style={buttonStyle}
      >{verb}</LoadingButton>
    </div>
  )
}
